// Who to phone to activate or close a flight plan. Not in the AIP data we
// read today, so it is kept here per country until it is (#176); Sweden has
// none yet and prints no line.

import { countryOfIcao } from './aerodromes'

export interface FplContact {
  unit: string
  phones: string[]
}

const FPL_CONTACTS: Record<'fi' | 'ee' | 'se', FplContact[]> = {
  fi: [{ unit: 'Tampere', phones: ['+358 33865172'] }],
  ee: [{ unit: 'Tallinn', phones: ['+372 6258254', '+372 6258374'] }],
  se: [],
}

/** The contacts for the countries of the given aerodromes, in route order, once each. */
export function fplContactsFor(icaoCodes: (string | null | undefined)[]): FplContact[] {
  const countries = [...new Set(icaoCodes.filter((c): c is string => !!c).map(countryOfIcao))]
  return countries.flatMap((country) => FPL_CONTACTS[country])
}
